// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pmjW","field":"styles_field__1dP0A","fieldCol":"styles_fieldCol__2PVne","diffCol":"styles_diffCol__20osI","diff":"styles_diff__2JvMM"};